import { Heading } from 'components/text';
import styles from './Introduction.module.scss';
import Container from 'components/container';

const Introduction: React.FC = () => (
  <Container as="section" className={styles.introduction}>
    <Heading as="h2"fontSize={18} color="grey-dark" weight={'medium'}>
      Destination guides, hotel reviews, insider tips and travel blogs through a
      luxury lens.
    </Heading>
  </Container>
);

export default Introduction;
